module.exports = __webpack_public_path__ + "img/1_Dicks_Screen_L_3_L.1b1cbdb5.jpg";